// This file is automatically generated. Do not edit manually.

import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource";
import { PostalAddressDto } from "src/api/generated/erp/erpUtils/postalAddressDto";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { IsoDateTimeString } from "src/types/dateTime";
import { Country } from "src/api/generated/io/aavo/applications/db/erp/types/country";
import { DeliveryState } from "src/api/generated/erp/db/types/enums/deliveryState";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveriesDataGridApi {
	export async function getDeliveriesUsableForSource(args: {
		deliverySource: DeliveryPackageSource;
		siteId: number;
		deliveryAddress: PostalAddressDto;
		deliveryMethodId: number | null | undefined;
		onlyUndelivered: boolean;
		searchQuery: string;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesUsableForSource",
			method: "POST",
			data: {
				deliverySource: args.deliverySource,
				siteId: args.siteId,
				deliveryAddress: args.deliveryAddress,
				deliveryMethodId: args.deliveryMethodId,
				onlyUndelivered: args.onlyUndelivered,
				searchQuery: args.searchQuery,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getDeliveriesForAllProjectDeliveriesView(args: {
		searchQuery: string;
		onlyUndelivered: boolean;
		siteId: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesForAllProjectDeliveriesView",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				onlyUndelivered: args.onlyUndelivered,
				siteId: args.siteId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getDeliveriesConnectedToProject(args: {
		projectId: number;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesConnectedToProject",
			method: "POST",
			data: {
				projectId: args.projectId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getDeliveriesForAllCustomerOrderDeliveriesView(args: {
		searchQuery: string;
		onlyUndelivered: boolean;
		siteId: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesForAllCustomerOrderDeliveriesView",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				onlyUndelivered: args.onlyUndelivered,
				siteId: args.siteId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getDeliveriesForCustomer(args: {
		customerId: number;
		searchQuery: string;
		onlyUndelivered: boolean;
		siteId: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesForCustomer",
			method: "POST",
			data: {
				customerId: args.customerId,
				searchQuery: args.searchQuery,
				onlyUndelivered: args.onlyUndelivered,
				siteId: args.siteId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getDeliveriesConnectedToCustomerOrder(args: {
		customerOrderId: number;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesConnectedToCustomerOrder",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getTransportDeliveries(args: {
		deliveryTransportId: number;
		setImageUrls?: boolean;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getTransportDeliveries",
			method: "POST",
			data: {
				deliveryTransportId: args.deliveryTransportId,
				setImageUrls: args.setImageUrls,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getDeliveriesOnLoadingJobQueue(): Promise<Array<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getDeliveriesOnLoadingJobQueue",
			method: "POST",
			data: {},
		});
		return response as Array<DeliveriesDataGridApi_DeliveryDto>;
	}

	export async function getTransportDeliveriesForCargoDriver(args: {
		deliveryTransportId: number;
		setImageUrls?: boolean;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getTransportDeliveriesForCargoDriver",
			method: "POST",
			data: {
				deliveryTransportId: args.deliveryTransportId,
				setImageUrls: args.setImageUrls,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<DeliveriesDataGridApi_DeliveryDto>;
	}
}

export interface DeliveriesDataGridApi_DeliveryDto {
	allPackagesLoaded: boolean;
	connectedCustomerOrders: Array<DeliveriesDataGridApi_DeliveryDto_CustomerOrderDto>;
	connectedProjects: Array<DeliveriesDataGridApi_DeliveryDto_ProjectDto>;
	imageUrl: string | null | undefined;
	actualDeliveryDate: IsoDateTimeString | null | undefined;
	cargoDriverId: number | null | undefined;
	cargoDriverName: string | null | undefined;
	createdByUserId: number;
	createdByUserName: string;
	createdDate: IsoDateTimeString;
	createdFromPurchaseOrderReceiptId: number | null | undefined;
	deliveryAddress_1: string;
	deliveryAddress_2: string;
	deliveryCity: string;
	deliveryCountry: Country;
	deliveryId: number;
	deliveryMethodCode: string | null | undefined;
	deliveryMethodId: number | null | undefined;
	deliveryMethodTransportDuration: number | null | undefined;
	deliveryName: string;
	deliveryPostalCode: string;
	deliveryState: DeliveryState;
	deliveryTransportDescription: string | null | undefined;
	deliveryTransportId: number | null | undefined;
	isDeliverable: boolean;
	lastUpdated: IsoDateTimeString;
	note: string;
	phone: string | null | undefined;
	plannedLoadingDate: IsoDateTimeString;
	plannedUnloadingDate: IsoDateTimeString;
	recipientContact: string;
	recipientDescription: string;
	senderAddressDescription_1: string;
	senderAddressDescription_2: string;
	senderAddress_1: string;
	senderAddress_2: string;
	senderCity: string;
	senderContact: string;
	senderCountry: Country;
	senderPostalCode: string;
	siteId: number;
	siteName: string;
	trackingCode: string;
	transportRouteId: number | null | undefined;
}

export interface DeliveriesDataGridApi_DeliveryDto_CustomerOrderDto {
	customerName: string;
	customerOrderId: number;
	deliveryNotes: string;
	imageUrl: string | null | undefined;
	orderReference: string;
}

export interface DeliveriesDataGridApi_DeliveryDto_ProjectDto {
	projectDescription: string;
	projectId: number;
}
